import React from 'react';

import { Avatar, Card, CardActions, CardHeader, Chip } from 'components';
import { Link, withRouter } from 'react-router-dom';

const ToolCard = ({
  name,
  slug,
  description = '',
  imageUrl,
  categories = [],
  onCardClick,
  style,
}) => {
  return (
    <Card style={style} onClick={onCardClick}>
      <Link to={`/tool/${slug}`}>
        <CardHeader
          title={name}
          subtitle={description}
          avatar={<Avatar src={imageUrl} style={{ borderRadius: 0 }} />}
        />
      </Link>

      <CardActions
        style={{ overflowX: 'scroll', padding: 0, margin: '4px 12px' }}
      >
        {categories &&
          categories.map(({ id, label, slug }) => {
            return <Chip key={id} label={label} />;
          })}
      </CardActions>
    </Card>
  );
};

export default withRouter(ToolCard);



// WEBPACK FOOTER //
// ./src/App/Tool/components/ToolCard.js